// extracted by mini-css-extract-plugin
module.exports = {"success":"Snack_success__1wDGX","warning":"Snack_warning__63KNx","error":"Snack_error__2UMvO","snackButton":"Snack_snackButton__3dE58","snackRoot":"Snack_snackRoot__1ZNqL"};